import { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import { getBlogs } from '../../actions/blogs';
import PageWithHeader from '../../components/PageWithHeader/PageWithHeader';
import { buildSourceURL, changeDescription } from '../../utils/functions';
import styles from './BlogList.module.css';

const Blog = (props) => {
  const { blogs, getBlogs } = props;

  useEffect(() => {
    getBlogs();
    const description = 'Explore expert tips on weight loss, meal prep, smart grocery shopping, and nutrition. The MealWell Blog helps you eat better — one article at a time.';
    changeDescription(description);
  }, []);

  const renderItem = (blog, index) => {
    if (blog.type === 'article') {
      const { article } = blog;
      return (
        <Link 
          key={index} 
          className={styles.blogItem}
          to={`/blog/${article.id}`}
        >
          <div className={styles.blogImage}>
            <img 
              className={styles.articleImage}
              src={buildSourceURL(article.image)} 
              alt={article.title} 
            />
          </div>
          <div className={styles.blogContent}>
            <div className={styles.blogTitle}>
              {article.title}
            </div>
            <div className={styles.blogDescription}>
              {article.description}
            </div>
          </div>
        </Link>
      );
    }

    const { banner } = blog;

    return (
      <a 
        key={index} 
        href={banner.link} 
        className={styles.bannerItem}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img 
          className={styles.bannerImage}
          src={buildSourceURL(banner.image)} 
          alt="Banner" 
        />
      </a>
    );
  };

  return (
    <>
      <Helmet>
        <title>
          Healthy Eating & Meal Planning Tips | MealWell Blog
        </title>
      </Helmet>
      <PageWithHeader>
        <div className={styles.wrapper}>
          <div className={styles.title}>
            Nutrition
          </div>
          <div className={styles.subTitle}>
            Discover food facts, recipes, and more from Meal Well experts.
          </div>
          <div className={styles.blogsList}>
            {blogs?.map(renderItem)}
          </div>
        </div>
      </PageWithHeader>
    </>
  );
};

const mapStateToProps = (state) => ({
  blogs: state.blog.blogsData,
});

const mapDispatchToProps = {
  getBlogs,
};

export default connect(mapStateToProps, mapDispatchToProps)(Blog);